import { useEffect } from 'react';
import { getSelectedLanguage, setSelectedLanguage } from '@shared/config/translations';
import { fromBackendLocale } from '@entities/user';

/**
 * Applies the backend's `preferredLanguage` once the user record is
 * loaded (login, refresh, new browser).
 *
 * Rules from the contract:
 *   - `null` means "never chosen", NOT English: nothing is applied and
 *     nothing is written back. The client keeps whatever it does today
 *     (localStorage / default).
 *   - A non-null value wins over the local cache, because the backend
 *     is the cross-device source of truth.
 *   - A locale the dashboard has no catalogue for (`ht`, `vi_VN`) maps
 *     to null and is ignored the same way.
 *
 * Applying means persisting locally and reloading once: the i18next
 * resources behind the legacy screens load on init only, so a switch
 * without a reload would leave them in the old language. The reload is
 * self-limiting — after it, local equals backend and this is a no-op.
 */
const usePreferredLanguageSync = preferredLanguage => {
  useEffect(() => {
    if (!preferredLanguage) return;
    const language = fromBackendLocale(preferredLanguage);
    if (!language || language === getSelectedLanguage()) return;
    setSelectedLanguage(language);
    window.location.reload();
  }, [preferredLanguage]);
};

export default usePreferredLanguageSync;
